import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { Action, Col, Row } from "@op/opds.opux";
import { Message } from "react-message-context";
import { Redirect, withRouter } from "react-router-dom";
import { focusAtElement } from "../../utils/commonUtils";
import ActionByCustomerType from "../ActionByCustomerType";
import { ReactComponent as ErrorImg } from "../../assets/huoltosivu.svg";
import { ANALYTICS_EVENTS } from "../../utils/enums";

const ErrorPage = ({ FeedbackStore, RestStore, AnalyticsStore, history }) => {
  useEffect(() => {
    focusAtElement("#ROF-errorTitle");
    window.disableLinkInterruption();
    AnalyticsStore.sendActionEvent(ANALYTICS_EVENTS.error);
  }, [AnalyticsStore]);

  const redirectToFormPage =
    !RestStore.initialLoadError &&
    !FeedbackStore.isDirty &&
    !RestStore.fatalError;

  if (redirectToFormPage) {
    return <Redirect to="/" />;
  }

  return (
    <Row className="rof-error">
      <Col xs={12} md={7}>
        <h2 id="ROF-errorTitle" tabIndex={-1}>
          <Message id="error.title" />
        </h2>

        <p>
          <Message id="error.body" />
        </p>

        <p className="rof-error__link first">
          <Action
            className="skip-link-interruption"
            onClick={() => history.push("/")}
          >
            <Message id="error.link.form" />
          </Action>
        </p>
        <ActionByCustomerType
          text="error.link.frontpage"
          url="url.opfi"
          className="rof-error__link"
        />
      </Col>
      <Col xs={12} md={5}>
        <div className="rof-error__img">
          <ErrorImg />
        </div>
      </Col>
    </Row>
  );
};

export default withRouter(
  inject("FeedbackStore", "RestStore", "AnalyticsStore")(ErrorPage)
);
